import React, { Component } from "react";
import { Link } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";
import UsersTable from "./usersTable";
import { getUsers, deleteUser } from "./../../services/userService";
import "react-confirm-alert/src/react-confirm-alert.css";
import _ from "lodash";

class Users extends Component {
  state = { users: [], sortColumn: { key: "name", order: "asc" } };

  async componentDidMount() {
    const users = await getUsers();
    this.setState({ users });
  }

  handleDelete = async user => {
    confirmAlert({
      title: "Delete User",
      message: "Are you sure you want to delete '" + user.name + "'?",
      buttons: [
        {
          label: "Yes",
          onClick: async () => {
            const users = this.state.users.filter(s => s.id !== user.id);
            this.setState({ users });

            await deleteUser(user.id);
          }
        },
        {
          label: "No",
          onClick: () => {}
        }
      ]
    });
  };

  handleSort = sortColumn => {
    this.setState({ sortColumn });
  };

  getSortedData = () => {
    const { users, sortColumn } = this.state;
    const sorted = _.orderBy(users, [sortColumn.key], [sortColumn.order]);
    return { users: sorted };
  };

  render() {
    const { sortColumn } = this.state;
    const { users } = this.getSortedData();

    return (
      <div>
        <h2>Users</h2>
        <Link
          to="/users/new"
          className="btn btn-primary"
          style={{ marginBottom: 20 }}
        >
          <i className="fa fa-file" />
        </Link>
        <UsersTable
          users={users}
          sortColumn={sortColumn}
          onEdit={this.handleEdit}
          onDelete={this.handleDelete}
          onSort={this.handleSort}
        />
      </div>
    );
  }
}

export default Users;



// WEBPACK FOOTER //
// ./src/components/users/users.jsx